<template>
    <div class="border-gray-400 boder" v-if="step < navigation.getIndexStep(product.product_type, OrderStepType.COMPLETED)">
        <div class="p-3 bg-cta rounded-tl-md rounded-tr-md">
            <h2 class="text-black font-bold text-lg">Inscrição Gratuita</h2>
        </div>
        <div class="p-4 text-center bg-white flex">
            <div class="w-7/12 text-left">
                <p class="text-xs mb-3">Valor divulgado pela faculdade</p>
                <p class="text-xs">Desconto da faculdade </p>
                <p
                    v-if="!product?.is_full_period_discount && !!product?.discount_period"
                    class="text-gray-400">
                    <span v-if="!!product?.discount_instalments && product?.default_sale_price">
                        Depois de {{ product?.discount_instalments }} meses, pague R${{ usePrice(product?.default_sale_price) }}
                    </span>
                    <span v-else>
                        {{ product?.discount_period }}
                    </span>
                </p>
            </div>
            <div class="w-5/12 text-right">
                <p class="text-xs text-black font-semibold mb-3">R$ {{ usePrice(product?.regular_price) }}</p>
                <p class="text-xs text-green-400 font-semibold">(-) R$ {{ usePrice( product?.regular_price - product?.sale_price) }}</p>
            </div>
        </div>
        <div class="bg-gray-light flex px-4 py-3 items-start">
            <div class="text-left w-7/12 pr-2">
                <p class="text-base leading-5">Com essa bolsa, sua mensalidade será de:</p>
                <!-- <span class="text-gray-one italic text-xs" v-if="product?.institution?.partner_id !== getPartnerIdBySlug(Partner.YDUQS)">
                    {{product?.product_type === OrderCheckoutType.SUBSCRIPTION ? 'E ainda ganhe a 1° mensalidade por ' : '+ Taxa da matrícula por '}}<span class="font-semibold">R$ {{ usePrice(product?.subscription_price) }}*</span>
                </span>                 -->
            </div>
            <div class="w-5/12 pl-2 justify-end items-center h-14 flex">
                <h1 class="text-primary text-2xl font-extrabold leading-6">R$ {{ usePrice(product?.sale_price) }}</h1>
            </div>
        </div>
    </div>
    <div class="border-gray-400 boder" v-else>
        <div class="p-3 bg-cta rounded-tl-md rounded-tr-md">
            <h2 class="text-black font-bold text-lg">Inscrição Gratuita</h2>
        </div>
        <div class="p-4 bg-white text-left">
            <p class="font-bold text-base mb-1">Sua mensalidade ficou:</p>
            <p>
                <Icon class="text-green-400 mt-0 text-md inline-block" icon="tabler:arrow-down" />
                <span class="text-2xl font-bold">R$ {{ usePrice(product?.sale_price) }}</span>
                <span class="text-base font-bold">/mês</span>
                <span class="text-xs ml-2">Antes <span class="line-through">R${{ usePrice(product?.regular_price) }}/mês</span></span>
            </p>
            <p
                v-if="!product?.is_full_period_discount && !!product?.discount_period"
                class="text-gray-400">
                <span v-if="!!product?.discount_instalments && product?.default_sale_price">
                    Depois de {{ product?.discount_instalments }} meses, pague R${{ usePrice(product?.default_sale_price) }}
                </span>
                <span v-else>
                    {{ product?.discount_period }}
                </span>
            </p>
        </div>
        <div class="bg-gray-300 flex rounded-bl-md rounded-br-md p-3 items-center" v-if="product?.saved_amount">
            <p class="text-black font-bold text-xs w-5/12 leading-5">Economia total<br /> no final do curso:</p>
            <p class="font-extrabold text-2xl pl-3 text-blue-light">R$ {{ usePrice(product?.saved_amount) }}</p>
        </div>
    </div>
</template>
<script lang="ts" setup>
    import { useState } from "#imports";
    import { usePrice } from "~/composables/usePrice";
	import { storeToRefs } from "pinia";
	import { useCheckoutStore } from "~~/store/checkout";
    import { Icon } from "@iconify/vue";
    import { useNavigationStore } from "~~/store/navigation";
    import { OrderStepType } from "~~/enums/orderStepType";
    import { OrderCheckoutType } from "~~/enums/orderCheckoutType";
import { getPartnerIdBySlug, Partner } from "~~/enums/partner";
	const step: any = useState("step");
	const navigation = useNavigationStore();

	const checkout = useCheckoutStore();
	const { product } = storeToRefs(checkout);
</script>